import script from "./UserRole.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRole.vue?vue&type=script&setup=true&lang=js"

import "./UserRole.vue?vue&type=style&index=0&id=be71ffe0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be71ffe0"]])

export default __exports__